<template>
    <el-dialog :visible.sync="dialogVisible" :title="title" width="720px" :close-on-click-modal="true"
        :append-to-body="true" :lock-scroll="false" custom-class="policy-dialog">
        <div v-loading="loading" class="policy-content-wrapper">
            <div class="policy-html" v-if="!loading && content" v-html="content"></div>
            <p v-else-if="!loading && !content" class="policy-empty">No content available</p>
        </div>
    </el-dialog>
</template>

<script>
import { getPolicy } from '@/api/index'

// type -> aid 映射
const TYPE_AID_MAP = {
    agreement: 1,
    privacy: 2,
    law: 3
}

export default {
    name: 'PolicyDialog',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: 'agreement',
            validator: value => ['agreement', 'privacy', 'law'].includes(value)
        }
    },
    data() {
        return {
            loading: false,
            content: ''
        }
    },
    computed: {
        dialogVisible: {
            get() {
                return this.visible
            },
            set(val) {
                this.$emit('update:visible', val)
            }
        },
        title() {
            const map = {
                agreement: 'User Registration Agreement',
                privacy: 'Privacy Policy',
                law: 'Laws & Regulations'
            }
            return map[this.type] || 'Policy'
        }
    },
    watch: {
        visible(val) {
            if (val) {
                this.fetchContent()
            } else {
                this.content = ''
            }
        }
    },
    methods: {
        /** 根据类型获取协议内容 */
        async fetchContent() {
            const aid = TYPE_AID_MAP[this.type]
            if (!aid) return
            this.loading = true
            try {
                const res = await getPolicy({ aid })
                if (res.code == '1' && res.data && res.data.content) {
                    this.content = res.data.content
                } else {
                    this.content = ''
                }
            } catch (e) {
                console.error('getPolicy failed', e)
                this.content = ''
            } finally {
                this.loading = false
            }
        }
    }
}
</script>

<style lang="scss">
.policy-dialog {
    .el-dialog__body {
        padding: 16px 24px 24px;
        max-height: 70vh;
        overflow-y: auto;
    }

    .policy-content-wrapper {
        min-height: 100px;
    }

    .policy-html {
        font-size: 14px;
        line-height: 1.8;
        color: #333;

        h1,
        h2,
        h3,
        h4,
        h5,
        h6 {
            margin-top: 16px;
            margin-bottom: 8px;
            font-weight: 600;
        }

        p {
            margin-bottom: 8px;
        }

        img {
            max-width: 100%;
            border-radius: 4px;
        }
    }

    .policy-empty {
        text-align: center;
        color: #999;
        padding: 40px 0;
        font-size: 14px;
    }
}
</style>
